module.exports = __webpack_public_path__ + "static/media/chart-line-solid.fbad01f8.png";